import { SimpleModal } from '@sequencehq/core-components'
import { FC } from 'react'

export const UnmarkShippingContactDialog: FC<{
  title: string
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}> = ({ title, isOpen, onClose, onConfirm }) => {
  return (
    <SimpleModal
      data-testid="contacts.unmarkShippingDialog"
      variant="dialog"
      disableSubmitOnEnter
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelButtonText="Cancel"
      submitButtonText="Continue"
      onSubmit={async () => {
        await onConfirm()
        return true
      }}
    >
      This customer will no longer have a shipping contact. The contact will
      keep receiving invoice notifications and payment reminders.
    </SimpleModal>
  )
}
